
export const PayoutType = {
    selectedRechargableAmnt: 'selectedRechargableAmnt',
    setMoneyTransferTotalAmount: 'setMoneyTransferTotalAmount',
    setMoneyTransferSurChargeAmount: 'setMoneyTransferSurChargeAmount',
    showCreateOrderResponse: 'showCreateOrderResponse',
    setOrderId: 'setOrderId',
    setAmount: 'setAmount',
    setTxnAmount: 'setTxnAmount',
    setTxnsurcharge: 'setTxnsurcharge',
    setTxntotalAmoun: 'setTxntotalAmoun',
    setMoneyTransferProgress: 'setMoneyTransferProgress',
    setStatusEnqResponse: 'setStatusEnqResponse',
    setCreateOrderRes:'setCreateOrderRes',
    setCreteOrderReq:'setCreteOrderReq',
    setStatusEnqResponse:'setStatusEnqResponse',
    setFilterStartDate:'setFilterStartDate',
    setFilterEndDate:'setFilterEndDate',   
    setMerchantDetails:'setMerchantDetails',
    RESET: "RESET"
};